module.exports = __webpack_public_path__ + "img/c01_unitstartechtownwatch_Normal_ua.98842e68.webp";